<template>
    <v-row>
        <v-col cols=12 md="6" class="d-flex" v-for="transaction in transactions" :key="transaction.id">
            <transaction-data :transaction="transaction"/>
        </v-col>
        <v-col cols="12">
            <v-pagination
                v-if="pageCount > 1"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
            />
        </v-col>
        <v-overlay :value="loading">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-row>
</template>

<script>
    import TransactionData from '@/components/TransactionData'
    import transactionService from '@/services/admin/transaction-service'

    export default {
        components: { TransactionData },
        data: () => {
            return {
                pageCount: 0,
                transactions: null,
                page: 1,
                loading: false
            }
        },
        computed: {
            dealer() {
                return this.$store.getters.getDealer
            }
        },
        watch: {
            page() {
                this.getTransactions()
            }
        },
        created() {
            this.getTransactions()
        },
        methods: {
            getTransactions() {
                this.loading = true
                let filters = {}
                if (this.dealer) {
                    filters.dealer = this.dealer
                }
                transactionService.getTransactionsByFilter(this.page, filters, null, null).then(resp => {
                    this.transactions = resp.data
                    this.pageCount = resp.last_page
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        }
    }
</script>
